import React from 'react';
import injectSheet from 'react-jss';
import { fontFedra, fontLarge, fontSmall } from '../../constants';

const mediaQuery = {
  paragraph: {
    display: 'none'
  },
  '@media screen and (min-width:1150px)': {
    paragraph: {
      display: 'block'
    }
  }
};

const Paragraph = injectSheet(mediaQuery)(
  ({ classes: { paragraph }, fontSize, text }) => (
    <p
      className={paragraph}
      style={{
        fontSize,
        margin: 0,
        fontFamily: fontFedra,
        fontWeight: 300
      }}
    >
      {text}
    </p>
  )
);

export const HospitalName = ({ placeName, siteName }) => (
  <div
    style={{
      textAlign: 'right',
      marginRight: '20px'
    }}
  >
    <Paragraph fontSize={fontLarge} text={placeName} />
    <Paragraph fontSize={fontSmall} text={siteName} />
  </div>
);
